import { runDemo } from "../shared/demoRunner";
import { createMorphTargetsTestScene } from "./scene";

runDemo({ createScene: createMorphTargetsTestScene });
